// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"dffe4c71","198":"0ca6d20e","328":"18136a63","389":"bb4d2eba","655":"b486f2d3","845":"1535cb7d","869":"9b06b3d5","953":"18136a63"}[chunkId] + ".chunk.css";
};